import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, HomeIcon, DollarSignIcon, CalendarIcon, UserIcon } from 'lucide-react';
export function DealsKanban() {
  const stages = ['Lead', 'Pre-Approval', 'Live Deal', 'Approved', 'Conditions Met', 'Closing', 'Closed'];
  // Mock data for deals
  const mockDeals = [{
    id: '1001',
    title: 'Purchase - Sarah Strauss & Michael Bray',
    stage: 'Lead',
    value: '$425,000',
    address: '123 Main St, Anytown',
    closingDate: '2023-10-15',
    client: 'Sarah Strauss & Michael Bray'
  }, {
    id: '1002',
    title: 'Refinance - Emily Johnson',
    stage: 'Pre-Approval',
    value: '$350,000',
    address: '456 Oak Ave, Somewhere',
    closingDate: '2023-11-01',
    client: 'Emily Johnson'
  }, {
    id: '1003',
    title: 'Purchase - David Chen',
    stage: 'Pre-Approval',
    value: '$380,000',
    address: '789 Pine Rd, Elsewhere',
    closingDate: '2023-10-30',
    client: 'David Chen'
  }, {
    id: '1004',
    title: 'Purchase - Robert & Lisa Taylor',
    stage: 'Live Deal',
    value: '$425,000',
    address: '321 Maple Dr, Nowhere',
    closingDate: '2023-09-25',
    client: 'Robert & Lisa Taylor'
  }, {
    id: '1005',
    title: 'Purchase - Jennifer Smith',
    stage: 'Approved',
    value: '$510,000',
    address: '654 Elm St, Anywhere',
    closingDate: '2023-09-15',
    client: 'Jennifer Smith'
  }];
  // Function to filter deals by stage
  const getDealsForStage = (stage: string) => {
    return mockDeals.filter(deal => deal.stage === stage);
  };
  return <div data-id="element-1639">
      <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center mb-6" data-id="element-1640">
        <h1 className="text-2xl font-bold text-neutral-900" data-id="element-1641">Deals</h1>
        <div className="flex space-x-2" data-id="element-1642">
          <Link to="/deals/table" className="btn btn-outline" data-id="element-1643">
            Table View
          </Link>
          <button className="btn btn-primary" data-id="element-1644">
            <PlusIcon className="mr-2 h-4 w-4" data-id="element-1645" />
            New Deal
          </button>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-1646">
        <div className="grid grid-cols-7 gap-4 min-w-max pb-4" data-id="element-1647">
          {stages.map(stage => <div key={stage} className="w-72" data-id="element-1648">
              <div className="bg-neutral-100 rounded-lg p-4" data-id="element-1649">
                <div className="flex items-center justify-between mb-4" data-id="element-1650">
                  <h2 className="font-medium text-neutral-900" data-id="element-1651">{stage}</h2>
                  <span className="rounded-full bg-neutral-200 px-2 py-1 text-xs font-medium text-neutral-800" data-id="element-1652">
                    {getDealsForStage(stage).length}
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1653">
                  {getDealsForStage(stage).map(deal => <Link key={deal.id} to={`/deals/${deal.id}`} className="block bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow" data-id="element-1654">
                      <h3 className="text-sm font-medium text-primary-600" data-id="element-1655">
                        {deal.title}
                      </h3>
                      <div className="mt-2 space-y-1" data-id="element-1656">
                        <div className="flex items-center text-xs text-neutral-500" data-id="element-1657">
                          <DollarSignIcon className="h-3 w-3 mr-1" data-id="element-1658" />
                          {deal.value}
                        </div>
                        <div className="flex items-center text-xs text-neutral-500" data-id="element-1659">
                          <HomeIcon className="h-3 w-3 mr-1" data-id="element-1660" />
                          {deal.address}
                        </div>
                        <div className="flex items-center text-xs text-neutral-500" data-id="element-1661">
                          <CalendarIcon className="h-3 w-3 mr-1" data-id="element-1662" />
                          Closing:{' '}
                          {new Date(deal.closingDate).toLocaleDateString()}
                        </div>
                        <div className="flex items-center text-xs text-neutral-500" data-id="element-1663">
                          <UserIcon className="h-3 w-3 mr-1" data-id="element-1664" />
                          {deal.client}
                        </div>
                      </div>
                    </Link>)}
                  {getDealsForStage(stage).length === 0 && <div className="bg-white p-4 rounded-lg border border-dashed border-neutral-300 text-center" data-id="element-1665">
                      <p className="text-sm text-neutral-500" data-id="element-1666">
                        No deals in this stage
                      </p>
                      <button className="mt-2 text-xs text-primary-600 hover:text-primary-700" data-id="element-1667">
                        + Add deal
                      </button>
                    </div>}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}